export default "__VITE_PUBLIC_ASSET__7c25fe43__"